var _arguments = typeof arguments === "undefined" ? void 0 : arguments;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var intval = function intval() {
  return parseInt.apply(console, _arguments);
};
var floatval = function floatval() {
  return parseFloat.apply(console, _arguments);
};
var json_decode = function json_decode() {
  return JSON.parse.apply(console, _arguments);
};
var json_encode = function json_encode() {
  return JSON.stringify.apply(console, _arguments);
};
var explode = function explode(selector, string) {
  return string.toString().split(selector);
};
var implode = function implode(selector, array) {
  return array.join(selector);
};
var str_replace = function str_replace(find, replace, string) {
  if (typeof find == "array") {
    var temp = "";
    find.forEach(function (toFind) {
      if (temp == "") {
        temp = string.toString();
      }
      temp = temp.replace(toFind, replace);
    });
    return temp;
  }
  return string.replace(find, replace);
};
var is_int = function is_int(val) {
  if (parseInt(val) < parseFloat(val)) {
    return false;
  }
  return true;
};
var is_float = function is_float(val) {
  if (parseInt(val) < parseFloat(val)) {
    return true;
  }
  return false;
};
var isset = function isset(val) {
  if (typeof val !== "undefined") {
    return true;
  }
  return false;
};
var name_to_object = function name_to_object($name) {
  $switch = $name.toLocaleLowerCase();
  switch ($switch) {
    case "function":
      return Function;
      break;
    case "string":
      return String;
      break;
    case "object":
      return Object;
      break;
    case "array":
      return Array;
      break;
    default:
      if (isset(window[$name])) {
        return window[$name];
      } else if (isset(document[$name])) {
        return document[$name];
      } else {
        return null;
      }
      break;
  }
};
var instance_of = function instance_of($var, $class) {
  var $origin = $class;
  if (typeof $class == "string") {
    $class = name_to_object($class);
  }
  if ($class === null) {
    console.warn("not implemented", $origin);
    return false;
  }
  if ($var instanceof $class) {
    return true;
  }
  return false;
};
var is_array = function is_array(obj) {
  return isset(obj) && obj instanceof Array;
};
var is_string = function is_string(obj) {
  return isset(obj) && obj.constructor.name == 'String';
};
var array_search = function array_search(value, array) {
  return is_array(array) && isset(value) ? Array.indexOf(array, value) : false;
};
var strpos = function strpos($haystack, $neddle) {
  var $offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  if (!is_string($haystack) || !is_string($neddle) || !is_int($offset)) {
    if (is_int($offset)) {
      console.warn("The '$haystack' and 'neddle' must be a string!");
    } else {
      console.warn("The '$offset must be an integer'");
    }
    return false;
  }
  return $haystack.indexOf($neddle, $offset);
};
var in_array = function in_array($needle, $haystack) {
  if (!is_array($haystack)) {
    console.warn("The '$haystack' must be a array");
    return false;
  }
  var $index = $haystack.indexOf($needle) - 1;
  if ($index == -2) {
    return false;
  }
  return true;
};
var is_object = function is_object(obj) {
  return isset(obj) && !is_array(obj) && !is_float(obj) && !is_int(obj) && !is_string(obj) && obj instanceof Object;
};
var is_function = function is_function(obj) {
  return isset(obj) && obj instanceof Function;
};
var foreach = function foreach(arg, func) {
  if (!is_function(func)) {
    console.warn("The 'func' argument must be a function");
    return false;
  }
  if (!is_array(arg) || !is_object(arg)) {
    console.warn("The 'arg' argument must be a array or a object");
    return false;
  }
  if (func.length > 1) {
    for (var i in arg) {
      func(i, arg[i]);
    }
  } else {
    for (var i in arg) {
      func(arg[i]);
    }
  }
};
var isElement = function isElement(obj) {
  if (!isset(obj)) {
    return false;
  }
  if (obj instanceof HTMLElement) {
    //Using W3 DOM2 (works for FF, Opera and Chrome)
    return true;
  }
  return _typeof(obj) === "object" && obj.nodeType === 1 && _typeof(obj.style) === "object" && _typeof(obj.ownerDocument) === "object";
};
export { intval, floatval, json_decode, json_encode, explode, implode, str_replace, instance_of, isset, foreach, array_search, strpos, is_int, is_float, is_array, in_array, is_object, is_function, isElement };